import React from 'react';
import { RUN_TASK_WIDGET_ID, RunTaskWidget } from '@wix/agent-maker-run-task-widget';
export const AgentMakerRunTask = props => {
  return /*#__PURE__*/React.createElement(RunTaskWidget, props);
};
export const AGENT_MAKER_RUN_TASK_WIDGET = RUN_TASK_WIDGET_ID;
//# sourceMappingURL=AgentMakerRunTask.js.map